/**
 * @license
 */
import { Action } from '@ngrx/store';

// Model
import { UIJumbo } from '@api/models';

// Actions
export const SET_TITLE = '[UI Header Jumbo] Set title';
export const SET_CAPTION = '[UI Header Jumbo] Set caption';
export const SET_VARIANT = '[UI Header Jumbo] Set variant';
export const SHOW = '[UI Header Jumbo] Show';
export const HIDE = '[UI Header Jumbo] Hide';

/**
 *
 */
export class SetTitle implements Action {
    readonly type = SET_TITLE;
    constructor(public payload: string) {}
}

/**
 *
 */
export class SetCaption implements Action {
    readonly type = SET_CAPTION;
    constructor(public payload: string) {}
}

/**
 *
 */
export class SetVariant implements Action {
    readonly type = SET_VARIANT;
    constructor(public payload: string) {}
}

/**
 *
 */
export class Show implements Action {
    readonly type = SHOW;
}

/**
 *
 */
export class Hide implements Action {
    readonly type = HIDE;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/actions/ui-header/ui-jumbo.actions.ts